<template>
  <div>
    <nav id="sub">
      <div class="subnav-txt col-4-3">
        <h1>{{ routeTitle }}</h1>
        <p>{{ routeHeading }}</p>
      </div>
    </nav>
    <div class="Content">
      <div class="Content-group">
        <div class="Section">
          <div
            class="ActionsMenu"
          >
            <button
              class="Button Button--Blue"
              @click.stop="toggleEventMenu"
            >
              Create Event
            </button>

            <ul
              v-if="ui.showEventMenu"
              v-click-outside="toggleEventMenu"
              class="Menu"
            >
              <li>
                <router-link to="/create-event/static/basic-info">
                  <span class="Icon-s Icon-clipboard-list" /> Static Form
                </router-link>
              </li>
              <li>
                <router-link to="/create-event/dynamic/basic-info">
                  <span class="Icon-s Icon-bolt" /> Dynamic Form
                </router-link>
              </li>
            </ul>
          </div>
        </div>
        <div class="Section">
          <h3>Events</h3>
          <events-data-table />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import EventsDataTable from './data-tables/events-data-table.vue';
import DataTableMixin from '../../mixins/datatable-mixin';

export default {
  name: 'EventsLayout',
  components: {
    EventsDataTable,
  },
  mixins: [DataTableMixin],
  props: {
    routeTitle: {
      type: String,
      default: 'Events',
    },
    routeHeading: {
      type: String,
      default: 'Create and manage your events',
    },
  },
  data() {
    return {
      ui: {
        showEventMenu: false,
      },
    };
  },
  methods: {
    toggleEventMenu() {
      this.ui.showEventMenu = !this.ui.showEventMenu;
    },
  },
};
</script>

<style lang="less" scoped>
.Section {
  border: none;
}

.ActionsMenu {
  position: relative;
  display: inline-block;

  .Menu {
    border: 1px solid #e9e9e9;
    background: white;
    z-index: 1;
    right: 0;
    top: 38px;
    width: 200px;
    cursor: pointer;

    a {
      padding: 10px 10px 10px 20px ;
      display: block;
      color: #333333;

      .Icon-s {
        margin-right: 5px;
      }
      &.disabled {
        pointer-events: none;
        color: #e9e9e9;
      }
    }
    li:hover {
      background: #046ff0;

      a {
        color: white;
      }

    }
  }
}
</style>
